import { render, staticRenderFns } from "./list-clendar-switcher.vue?vue&type=template&id=215ad84a&scoped=true&"
import script from "./list-clendar-switcher.vue?vue&type=script&lang=js&"
export * from "./list-clendar-switcher.vue?vue&type=script&lang=js&"
import style0 from "./list-clendar-switcher.vue?vue&type=style&index=0&id=215ad84a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ad84a",
  null
  
)

export default component.exports